import formatDate from "helpers/format-date";

const searchForBlogs = (blogs, searchInput, language) =>
	blogs.filter(blog => {
		const formattedDate = formatDate(blog.date, language).toLowerCase();
		const blogTitle = blog.title.toLowerCase();
		const blogCategoryTitle = blog.category.title.toLowerCase();
		const blogExcerpt = blog.excerpt.toLowerCase();
		return searchInput.trim().split(" ")
			.some(input =>
				blogTitle.includes(input) ||
				blogCategoryTitle.includes(input) ||
				blogExcerpt.includes(input) ||
				formattedDate.includes(input)
			);
	});

export default searchForBlogs;